import React from 'react'
import Svg from './Svg'
export const SvgInfo = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zm-1.5 4.5h3v3h-3v-3zm4.5 15H9V18h1.5v-6H9v-1.5h4.5V18H15v1.5z" />
  </Svg>
))
SvgInfo.isIcon = true
export default SvgInfo
